import { ModuleConfig } from '@/core/module';
import { loanRepaymentRoutes } from './routes';
import { useLoanRepaymentStore } from './stores/loan-repayment-store';

export const LoanRepaymentModule: ModuleConfig = {
  name: 'loan-repayment',
  routes: loanRepaymentRoutes,
  stores: {
    loanRepayment: useLoanRepaymentStore,
  },
  initialize: () => {
    console.log('Loan Repayment module initialized');
  },
  cleanup: () => {
    console.log('Loan Repayment module cleaned up');
  },
};
